import {reactive, computed} from "@vue/composition-api";
import AuthenticationState from './AuthenticationState';

const state = reactive({
    data: localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null,
    client: localStorage.getItem('client') ? JSON.parse(localStorage.getItem('client')) : null,
    rememberMe: localStorage.getItem('remember_me') === 'true',
    lastApiCall: localStorage.getItem('last_api_call') ? new Date(localStorage.getItem('last_api_call')) : null,
});

const data = computed(() => state.data);
const client = computed(() => state.client);
const rememberMe = computed(() => state.rememberMe);
const lastApiCall = computed(() => state.lastApiCall);

const registerApiCallDate = () => {
    const now = new Date();
    localStorage.setItem('last_api_call', now.toISOString());
    state.lastApiCall = now;
};

const setRememberMe = () => {
  localStorage.setItem('remember_me', 'true');
  state.rememberMe = true;
};

const update = (profile) => {
    localStorage.setItem('signed', 'true');
    localStorage.setItem('profile', JSON.stringify(profile));
    state.data = profile;
};

const updateFromForm = (profileForm) => {
    state.data.firstName = profileForm.firstName;
    state.data.lastName = profileForm.lastName;
    state.data.fullName = profileForm.firstName + ' ' + profileForm.lastName;
    state.data.phone = profileForm.phone;
};

const clear = () => {
  AuthenticationState.clearTokens();
  localStorage.removeItem('profile');
  localStorage.removeItem('client');
  localStorage.removeItem('last_api_call');
  localStorage.removeItem('remember_me');
  state.data = null;
};

const profileState = {
    data,
    client,
    lastApiCall,
    rememberMe,
    setRememberMe,
    clear,
    registerApiCallDate,
    update,
    updateFromForm
};

export default profileState;
